import React from 'react'
import Layout from '../components/layout'
import { Disclosure } from '@headlessui/react'
import { TbChevronDown } from 'react-icons/tb'

const Faq = () => {
    return (
        <Layout>
            <div className='bg-[#f925390d] text-[#565656] pt-24 lg:pt-48 pb-12 lg:pb-24'>
                <p className='text-[40px] text-center font-bold'>Frequently Asked Questions</p>
            </div>

            <div className="w-full my-4 lg:my-9 lg:max-w-[1440px] mx-auto text-[#565656]">
                <div className="mx-[5%] lg:mx-[10%] space-y-9">
                    <Disclosure>
                        {({ open }) => (
                            <div className='border rounded-lg shadow-md'>
                                <Disclosure.Button className={`flex w-full justify-between border rounded-t-lg px-4 lg:px-8  py-2 lg:py-4 text-left `}>
                                    <span className='text-xl lg:text-3xl font-bold'>Glossary</span>
                                    <TbChevronDown
                                        className={`${open ? 'rotate-180 transform' : ''
                                            } h-5 w-5`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="px-8 lg:px-12 text-lg lg:text-2xl pt-4 lg:pt-7 pb-8 lg:pb-16">
                                    <ul className='list-disc space-y-4 lg:space-y-8 leading-10'>
                                        <li>
                                            <p><span className='font-medium'>CPM (Cost per mile)</span> – This is the cost per thousand impressions, indicating how much you pay for a thousand views of your ad.</p>
                                        </li>
                                        <li>
                                            <p><span className='font-medium'>CPC (Cost per click)</span> – This refers to the cost you incur each time a user clicks on your ad.</p>
                                        </li>
                                        <li>
                                            <p><span className='font-medium'>DSP (Demand-side platform)</span> – This is software used by advertisers to buy digital ad inventory programmatically, optimizing ad placements across various online platforms.</p>
                                        </li>
                                        <li>
                                            <p><span className='font-medium'>CPI (Cost per install)</span> - This measures the cost advertisers pay for each user who installs their mobile app.</p>
                                        </li>
                                        <li>
                                            <p><span className='font-medium'>SSP (Supply-side platform)</span> – They help publishers manage and sell their ad inventory to advertisers, maximizing revenue from available advertising space.</p>
                                        </li>
                                        <li>
                                            <p><span className='font-medium'>CTR (Click-through rate)</span> - This is the percentage of users who click on an ad after seeing it, calculated by dividing the number of clicks by the number of impressions.</p>
                                        </li>
                                        <li>
                                            <p><span className='font-medium'>Reach</span> - This is the total number of unique users exposed to an ad campaign over a specific time period.</p>
                                        </li>
                                        <li>
                                            <p><span className='font-medium'>Impressions</span> - This is the total number of times an ad is displayed or viewed by users, even if it's not clicked on.</p>
                                        </li>
                                        <li>
                                            <p><span className='font-medium'>Clicks</span>  -  This refers to user interactions with ads, quantifying the number of times individuals have actively engaged with the ad content through a click.</p>
                                        </li>
                                        <li>
                                            <p><span className='font-medium'>Engagement</span> - This measures how users interact with an ad, including actions like clicks, shares, likes, comments, and more.</p>
                                        </li>
                                        <li>
                                            <p><span className='font-medium'>Spend</span> - Spend refers to the total amount of money spent on an advertising campaign, including media buying, creative development, and other related costs.</p>
                                        </li>
                                        {/* <li>
                                            <p><span className='font-medium'></span></p>
                                        </li> */}
                                    </ul>
                                </Disclosure.Panel>
                            </div>
                        )}
                    </Disclosure>

                    <Disclosure>
                        {({ open }) => (
                            <div className='border rounded-lg shadow-md'>
                                <Disclosure.Button className={`flex w-full justify-between border rounded-t-lg px-4 lg:px-8  py-2 lg:py-4 text-left `}>
                                    <span className='text-xl lg:text-3xl font-bold'>How do we charge ?</span>
                                    <TbChevronDown
                                        className={`${open ? 'rotate-180 transform' : ''
                                            } h-5 w-5`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="px-8 lg:px-12 text-lg lg:text-2xl pt-4 lg:pt-7 pb-8 lg:pb-16">
                                    <ul className='list-disc space-y-2 lg:space-y-4 leading-10'>
                                        <li>
                                            <p>Cost Per Impression: where you pay based on how many times your ad was shown (not clicked).</p>
                                        </li>
                                        <li>
                                            <p>CPC (Cost Per Click): means you only pay for an ad if someone clicks on it.</p>
                                        </li>
                                        <li>
                                            <p>Cost Per Engagement: where you pay when a user completes a predefined engagement (like watching your video ad).</p>
                                        </li>
                                        {/* <li>
                                            <p></p>
                                        </li> */}
                                    </ul>
                                </Disclosure.Panel>
                            </div>
                        )}
                    </Disclosure>

                    <Disclosure>
                        {({ open }) => (
                            <div className='border rounded-lg shadow-md'>
                                <Disclosure.Button className={`flex w-full justify-between border rounded-t-lg px-4 lg:px-8  py-2 lg:py-4 text-left `}>
                                    <span className='text-xl lg:text-3xl font-bold'>What payment terms do we use ?</span>
                                    <TbChevronDown
                                        className={`${open ? 'rotate-180 transform' : ''
                                            } h-5 w-5`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="px-8 lg:px-12 text-lg lg:text-2xl pt-4 lg:pt-7 pb-8 lg:pb-16">
                                    <div className='space-y-2 leading-10'>
                                        <p>
                                            We work on a prepayment basis, that means that if you’re an advertiser and want to activate your DSP account you’ll have to fund it first. For the prepayment, we accept credit cards, wire transfer, flutterwave and PayPal.
                                        </p>
                                        <p>
                                            You can deposit the necessary funds directly through your DSP dashboard in the “Billing” section.
                                        </p>
                                        <p>
                                            After you deposit a certain amount of money on your account, you’re free to launch your ad campaign and bid for traffic.
                                        </p>
                                        {/* <p>

                                        </p> */}
                                    </div>
                                </Disclosure.Panel>
                            </div>
                        )}
                    </Disclosure>

                    <Disclosure>
                        {({ open }) => (
                            <div className='border rounded-lg shadow-md'>
                                <Disclosure.Button className={`flex w-full justify-between border rounded-t-lg px-4 lg:px-8  py-2 lg:py-4 text-left `}>
                                    <span className='text-xl lg:text-3xl font-bold'>Which tracking platform do we use ?</span>
                                    <TbChevronDown
                                        className={`${open ? 'rotate-180 transform' : ''
                                            } h-5 w-5`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="px-8 lg:px-12 text-lg lg:text-2xl pt-4 lg:pt-7 pb-8 lg:pb-16">
                                    <div className='space-y-2 leading-10'>
                                        <p>
                                            We have our own RTB tracking platform with an intuitive technology core, that includes a complex of tools for gathering, analyzing and data segmentation.
                                        </p>
                                        <p>
                                            Our tracking platform is able to collect the necessary customer data and process it to provide the most complete picture.
                                        </p>
                                    </div>
                                </Disclosure.Panel>
                            </div>
                        )}
                    </Disclosure>

                    <Disclosure>
                        {({ open }) => (
                            <div className='border rounded-lg shadow-md'>
                                <Disclosure.Button className={`flex w-full justify-between border rounded-t-lg px-4 lg:px-8  py-2 lg:py-4 text-left `}>
                                    <span className='text-xl lg:text-3xl font-bold'>How to Generate a Report</span>
                                    <TbChevronDown
                                        className={`${open ? 'rotate-180 transform' : ''
                                            } h-5 w-5`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="px-8 lg:px-12 text-lg lg:text-2xl pt-4 lg:pt-7 pb-8 lg:pb-16">
                                    <ul className='list-disc space-y-2 lg:space-y-4 leading-10'>
                                        <li>
                                            <p>Access Your Advertiser Account: Log in to your advertiser account on the platform.</p>
                                        </li>
                                        <li>
                                            <p>Navigate to the Top Bar: Look at the top navigation bar for menu options.</p>
                                        </li>
                                        <li>
                                            <p>Select "Invoicing": Click on the "Invoicing" option from the menu.</p>
                                        </li>
                                        <li>
                                            <p>Choose a Time Period: Within the "Invoicing" section, you'll find a selection for the reporting period. You can select a specific time frame.</p>
                                        </li>
                                        <li>
                                            <p>Select Report Interval: You have the option to choose between a daily interval or a total summary, depending on your reporting needs.</p>
                                        </li>
                                        <li>
                                            <p>Click "Get Report": After selecting the time period and report interval, click the "Get Report" button.</p>
                                        </li>
                                        <li>
                                            <p>View Report in Table Format: A table-like format will appear on your screen, displaying comprehensive details of your campaign performance.</p>
                                        </li>
                                        <li>
                                            <p>Download the Report: To keep a record or share the report, you can download it in either Excel or PDF format.</p>
                                        </li>
                                        {/* <li>
                                            <p></p>
                                        </li> */}
                                    </ul>
                                    <p className='mt-6 lg:mt-12 -ml-4 lg:-ml-8'>By following these steps, you can effortlessly generate a report to analyze and track the progress of your campaigns within your advertiser account.</p>
                                </Disclosure.Panel>
                            </div>
                        )}
                    </Disclosure>

                    <Disclosure>
                        {({ open }) => (
                            <div className='border rounded-lg shadow-md'>
                                <Disclosure.Button className={`flex w-full justify-between border rounded-t-lg px-4 lg:px-8  py-2 lg:py-4 text-left `}>
                                    <span className='text-xl lg:text-3xl font-bold'>How to Set up a Campaign</span>
                                    <TbChevronDown
                                        className={`${open ? 'rotate-180 transform' : ''
                                            } h-5 w-5`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="px-8 lg:px-12 text-lg lg:text-2xl pt-4 lg:pt-7 pb-8 lg:pb-16">
                                    <ul className='list-disc space-y-2 lg:space-y-4 leading-10'>
                                        <li>
                                            <p>Login to Your Account: Begin by logging in to your account on our platform using your credentials. </p>
                                        </li>
                                        <li>
                                            <p>Once logged in, navigate to the campaign menu. You can find this menu in the top navigation or sidebar of your dashboard.</p>
                                        </li>
                                        <li>
                                            <p>Within the campaign menu, locate and click on the "Create Campaign" option. This will initiate the campaign setup process.</p>
                                        </li>
                                        <li>
                                            <p>You will then be directed to the campaign setup page. Start by filling in the basic information for your campaign. </p>
                                        </li>
                                        <li>
                                            <p>Next, proceed to the targeting section. Define your target audience by specifying demographics, location, interests, and any other relevant criteria. </p>
                                        </li>
                                        <li>
                                            <p>Choose where your ads will be displayed. Select the platforms, websites, or channels where you want your campaign to appear. </p>
                                        </li>
                                        <li>
                                            <p>Put in your ad creatives, including images, videos, ad copy, and any interactive elements. Ensure your creatives align with your campaign objectives and target audience.</p>
                                        </li>
                                        <li>
                                            <p>Click on the "Launch" button to activate your campaign. Your ads will now begin running according to the specified parameters.</p>
                                        </li>
                                        <li>
                                            <p>Remember to monitor the performance of your campaign regularly and make adjustments as needed to optimize results. </p>
                                        </li>
                                        <li>
                                            <p>If you encounter any issues or have questions during the setup process, don't hesitate to reach out to our support team for assistance. </p>
                                        </li>
                                        {/* <li>
                                            <p></p>
                                        </li> */}
                                    </ul>
                                </Disclosure.Panel>
                            </div>
                        )}
                    </Disclosure>

                    <Disclosure>
                        {({ open }) => (
                            <div className='border rounded-lg shadow-md'>
                                <Disclosure.Button className={`flex w-full justify-between border rounded-t-lg px-4 lg:px-8  py-2 lg:py-4 text-left `}>
                                    <span className='text-xl lg:text-3xl font-bold'>Become a Dochase Partner</span>
                                    <TbChevronDown
                                        className={`${open ? 'rotate-180 transform' : ''
                                            } h-5 w-5`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="px-8 lg:px-12 text-lg lg:text-2xl pt-4 lg:pt-7 pb-8 lg:pb-16">
                                    <p className='-ml-4 lg:-ml-8 leading-10'>Are you a senior sales or experienced marketing executive within the advertising industry? We have an exciting opportunity for you to boost your income and become your own boss, no matter where you are in the world.</p>
                                    <p className='-ml-4 lg:-ml-8 leading-10'>To be eligible for this exclusive program, all you need to do is spend a minimum of $5,000 in advertising with Dochase for three consecutive months. Once you meet this qualification, you're on your way to becoming a Dochase partner.</p>
                                    <p className='mt-6 lg:mt-12 -ml-4 lg:-ml-8 font-medium'>Benefits of Becoming a Dochase Partner</p>
                                    <ul className='list-disc space-y-2 lg:space-y-4 leading-10'>
                                        <li>
                                            <p><span className='font-medium'>Financial Empowerment:</span> As a Dochase partner, you have the potential to significantly increase your income by leveraging our advertising solutions.</p>
                                        </li>
                                        <li>
                                            <p><span className='font-medium'>Global Reach:</span> Work from any corner of the world and still access the full range of Dochase resources and support. </p>
                                        </li>
                                        <li>
                                            <p><span className='font-medium'>Personalized Assistance:</span> Need us to join you in client meetings or require our presence to help close campaigns? Our team is here to support your success. </p>
                                        </li>
                                    </ul>
                                    <p className='mt-6 lg:mt-12 -ml-4 lg:-ml-8'>Join our growing community of empowered Marketing Executives who are taking control of their careers and financial futures. </p>
                                    <p className='mt-6 lg:mt-12 -ml-4 lg:-ml-8'>Ready to embark on this exciting journey? Kindly complete the form and let’s get started.</p>
                                </Disclosure.Panel>
                            </div>
                        )}
                    </Disclosure>

                    <Disclosure>
                        {({ open }) => (
                            <div className='border rounded-lg shadow-md'>
                                <Disclosure.Button className={`flex w-full justify-between border rounded-t-lg px-4 lg:px-8  py-2 lg:py-4 text-left `}>
                                    <span className='text-xl lg:text-3xl font-bold'>Earn a White Label and get your Advertising Tech stack</span>
                                    <TbChevronDown
                                        className={`${open ? 'rotate-180 transform' : ''
                                            } h-5 w-5`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="px-8 lg:px-12 text-lg lg:text-2xl pt-4 lg:pt-7 pb-8 lg:pb-16">
                                    <p className='-ml-4 lg:-ml-8 leading-10'>Gain access to exclusive benefits, including our White Label and a customized advertising software. Take full control and make it your own.</p>
                                    <p className='mt-6 lg:mt-12 -ml-4 lg:-ml-8 font-medium'>To earn the White Label, You must meet the following criteria:</p>
                                    <ul className='list-disc space-y-2 lg:space-y-4 leading-10'>
                                        <li>
                                            <p>Spend a minimum of $5,000 over a three-month period. This ensures a dedicated and substantial investment in advertising campaigns.</p>
                                        </li>
                                        <li>
                                            <p>Partner with us for a minimum of six months, demonstrating a commitment to a strong and lasting collaboration.</p>
                                        </li>
                                    </ul>
                                    <p className='mt-3 lg:mt-6 -ml-4 lg:-ml-8'>By meeting these requirements, you gain access to </p>
                                    <ul className='list-disc space-y-2 lg:space-y-4 leading-10'>
                                        <li>
                                            <p>A customized software which can be tailored to your specific needs and branding.</p>
                                        </li>
                                        <li>
                                            <p>Your unique Advertising Tech Stack where you can establish your campaigns.</p>
                                        </li>
                                    </ul>
                                    <p className='mt-6 lg:mt-12 -ml-4 lg:-ml-8 leading-10'>This means you can confidently offer your clients top-notch advertising solutions, enhance brand visibility, and drive superior results—all while building a strong, independent presence in the advertising industry. We value our agency partners and believe in rewarding their commitment. </p>
                                    <p className='-ml-4 lg:-ml-8 font-medium mt-2'>Come partner with us today!</p>
                                </Disclosure.Panel>
                            </div>
                        )}
                    </Disclosure>
                </div>
            </div>
        </Layout>
    )
}

export default Faq